import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { ArrowUpRight } from "lucide-react";

export default function ProjectModal({ project, open, onOpenChange }) {
  if (!project) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid="project-modal"
        className="bg-[#0a0a0a] border border-white/10 text-white max-w-3xl p-0 overflow-hidden"
      >
        <div className="relative aspect-[16/9] overflow-hidden">
          <img
            src={project.image}
            alt={project.title}
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent" />
        </div>
        <div className="p-6 md:p-8">
          <div className="flex flex-wrap items-center gap-2 mb-3">
            <Badge className="bg-blue-500/15 text-blue-300 border-blue-500/30 hover:bg-blue-500/20">
              {project.tech}
            </Badge>
            {project.industry && (
              <Badge variant="outline" className="border-white/15 text-zinc-300">
                {project.industry}
              </Badge>
            )}
          </div>
          <DialogHeader>
            <DialogTitle className="font-display text-3xl md:text-4xl tracking-tight text-white">
              {project.title}
            </DialogTitle>
            <DialogDescription className="text-zinc-400 text-base md:text-lg pt-2 leading-relaxed">
              {project.description}
            </DialogDescription>
          </DialogHeader>
          <div className="mt-6 flex items-center gap-3">
            <a
              data-testid="project-modal-visit-link"
              href={project.url}
              target="_blank"
              rel="noreferrer noopener"
              className="inline-flex items-center gap-2 rounded-full bg-blue-500 hover:bg-blue-400 text-white text-sm font-medium px-5 py-2.5 transition-colors"
            >
              Visit live site <ArrowUpRight size={16} />
            </a>
            <span className="text-zinc-500 text-sm">{project.url.replace(/^https?:\/\//, "")}</span>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
